import { Modifier } from '../modifier';
import {
  ModifierPriority,
  ModifierTags,
  StatusEffect,
  type ModifierParams,
} from '../modifier.type';
import { addModifier, type Player } from '../player.type';
import { actionHistory } from '../../../store';
import type { Die } from '../die.type';
import { StatusEffectRegistry } from '../status-effects';

export class Delay extends Modifier {
  static readonly baseTitle = 'Delay';
  static readonly baseText = 'Will apply the effect at the start of the next turn.';
  static readonly baseIcon = 'delay';
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Delay.baseTitle;
  text = Delay.baseText;
  icon = Delay.baseIcon;
  tags: Array<ModifierTags> = [];
  priority = Delay.basePriority;

  init(params?: ModifierParams) {
    super.init(params);
    if (params?.imbue) {
      this.properties.imbue = params.imbue;
      const effectInstance = StatusEffectRegistry.create(params.imbue, this.owner, 0);
      this.bonusIcon = effectInstance.icon;
      this.tags = [...effectInstance.tags];
    }
  }

  update(stacks: number, params?: ModifierParams) {
    if (!params?.imbue) {
      throw new Error('Delay modifier requires imbue type in params.');
    }

    if (this.properties.imbue !== params.imbue) {
      actionHistory.push(
        `${this.owner.title} changed delay from ${this.properties.imbue} to ${params.imbue}.`,
      );
      this.properties.imbue = params.imbue;
      this.title = `${this.type} (${this.properties.imbue})`;
      const effectInstance = StatusEffectRegistry.create(params.imbue, this.owner, 0);
      this.bonusIcon = effectInstance.icon;
      this.stacks = stacks || this.stacks;
    }

    if (stacks) {
      this.stacks += stacks;
      actionHistory.push(`Added ${stacks} ${this.type} to ${this.owner.title}.`);
    }

    const effectInstance = StatusEffectRegistry.create(this.properties.imbue, this.owner, 0);
    this.tags = [...effectInstance.tags];
  }

  startTurn({
    dice,
    rerollMax,
    activePlayer,
    inactivePlayer,
  }: {
    dice: any;
    rerollMax: any;
    activePlayer: any;
    inactivePlayer: any;
  }): void | { dice: Die[]; rerollMax: number; activePlayer: Player; inactivePlayer: Player } {
    addModifier(activePlayer, this.properties.imbue as StatusEffect, this.stacks);

    this.removeStacks(this.stacks);
    return { dice, rerollMax, activePlayer, inactivePlayer };
  }

  getHTML(): string {
    if (!this.properties.imbue) return '';
    const effectInstance = StatusEffectRegistry.create(this.properties.imbue, this.owner, 0);
    return `
      <h3> ${this.properties.imbue} </h3>
      <p> ${effectInstance.text} </p>
    `;
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Delay, Delay);
